/* eslint-disable camelcase */
import apiCus from '../../services/service_customer'
import apiItem from '../../services/service_item.js'
import apiUser from '../../services/service.js'
import Swal from 'sweetalert2'
import moment from 'moment'
export default {
  data () {
    return {
      cus_age: 0,
      last_date: new Date(),
      title: 'ปรับปรุงสินค้า',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      modal_active: false,
      modal_data: {
        'company_id': 1,
        'branch_id': 1,
        'doc_no': '',
        'doc_date': moment(new Date()).format('YYYY-MM-DD'),
        'ap_code': JSON.parse(sessionStorage.user).user_code,
        'rp_code': '',
        'description': '',
        'total_amount': 0,
        'is_cancel': 0,
        'sub': []
      },
      modal_title: '',
      list_bill: [],
      data_ap: [],
      data_rp: [],
      modal_item_active: false,
      data_item: [],
      unit: [],
      modal_data_item: {
        'id': 0,
        'item_id': 0,
        'item_code': '',
        'item_name': '',
        'short_name': '',
        'adjust_type': 0,
        'description': '',
        'wh_id': 1,
        'wh_code': '01',
        'shelf_id': 1,
        'shelf_code': '01',
        'qty': 0,
        'unit_id': 0,
        'unit_code': '',
        'average_cost': 0,
        'sum_of_cost': 0,
        'stock_type': 0,
        'rate1': 1,
        'rate2': 1,
        'is_cancel': 0
      },
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      return this.list_bill.filter(adjusList => {
        return (
          adjusList.doc_no.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    adjustDef (val) {
      switch (val) {
        case 0:
          return 'ลด'
        case 1:
          return 'เพิ่ม'
        default:
          return 'n/a'
      }
    },
    selectText (val) {
      document.getElementById(val).select()
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    handleChange (value) {
      console.log(`selected ${value}`)
    },
    handleChange1 (value) {
      console.log(`selected ${value}`)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    filterOption1 (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    select (address) {
      this.modal_data.sub_district = address.district
      this.modal_data.district = address.amphoe
      this.modal_data.province = address.province
      this.modal_data.post_code = address.zipcode
    },
    editBill (code) {
      this.$store.commit('Loading')
      let body = {
        'doc_no': code
      }
      apiItem.getAdjust(this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.modal_title = 'แก้ไขเอกสาร'
            this.modal_active = true
            this.modal_data = result.data
          } else {
            this.$notification['warning']({
              message: 'ไม่สามารถดึงข้อมูลเอกสาร',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    close_modal () {
      this.modal_active = false
      this.modal_data = {
        'company_id': 1,
        'branch_id': 1,
        'doc_no': '',
        'doc_date': moment(new Date()).format('YYYY-MM-DD'),
        'ap_code': JSON.stringify(sessionStorage.user.user_code),
        'rp_code': '',
        'description': '',
        'total_amount': 0,
        'is_cancel': 0,
        'sub': []
      }
    },
    getAll () {
      this.$store.commit('Loading')
      let body = {
        'keyword': this.search,
        'limit': 50,
        'status': 1
      }
      apiItem.listAdjust(this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.list_bill = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    removeBill (code) {
      Swal.fire({
        title: 'ยกเลิกเอกสาร',
        text: 'ท่านต้องการยกเลิกเอกสาร ' + code + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ปฏิเสธ',
        cancelButtonColor: 'red',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.commit('Loading')
          var body = {
            'doc_no': code
          }
          apiItem.removeAdjust(this.REST_URL,
            this.header,
            body,
            result => {
              if (result.response === 'success') {
                this.getAll()
                this.$notification['success']({
                  message: 'ยกเลิกเอกสารสำเร็จ',
                  description: code
                })
              } else {
                this.$notification['warning']({
                  message: 'ยกเลิกเอกสารไม่สำเร็จ',
                  description:
                    result.message
                })
              }
              this.$store.commit('Loading')
            },
            error => {
              alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            }
          )
        }
      })
    },
    action_modal () {
      if (this.modal_data.code === '') {
        this.addCus()
      } else {
        this.updateCus()
      }
    },
    ConfirmBill () {
      if (this.modal_data.doc_no) {
        this.editAdjust()
      } else {
        this.addAdjust()
      }
    },
    addAdjust () {
      this.$store.commit('Loading')
      // this.modal_data.birth_date = moment(this.modal_data.birth_date).format('YYYY-MM-DD')
      // this.modal_data.credit_day = parseInt(this.modal_data.credit_day)
      apiItem.createAdjust(this.REST_URL,
        this.header,
        this.modal_data,
        result => {
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'เพิ่มข้อมูลสำเร็จ',
              description:
                      result.message
            })
            this.getAll()
            this.close_modal()
          } else {
            this.$notification['warning']({
              message: 'เพิ่มข้อมูลไม่สำเร็จ',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    editAdjust () {
      this.$store.commit('Loading')
      // this.modal_data.birth_date = moment(this.modal_data.birth_date).format('YYYY-MM-DD')
      // this.modal_data.credit_day = parseInt(this.modal_data.credit_day)
      // this.modal_data.debt_limit = parseInt(this.modal_data.debt_limit)
      // this.modal_data.debt_balance = parseInt(this.modal_data.debt_balance)
      // this.modal_data.active_status = parseInt(this.modal_data.active_status)
      apiItem.updateAdjust(this.REST_URL,
        this.header,
        this.modal_data,
        result => {
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'แก้ไขข้อมูลสำเร็จ',
              description:
                      result.message
            })
            this.getAll()
            this.close_modal()
          } else {
            this.$notification['warning']({
              message: 'แก้ไขข้อมูลไม่สำเร็จ',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getCusAll () {
      this.$store.commit('Loading')
      let body = {
        'keyword': '',
        'limit': 1000000,
        'status': 1
      }
      apiCus.listAll(
        this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            // console.log(result)
            this.data_rp = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getUserAll () {
      this.$store.commit('Loading')
      let body = {
        'keyword': this.search_keyword,
        'limit': 500,
        'status': 1
      }
      // console.log(header)
      apiUser.listUser(this.REST_URL,
        {},
        body,
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.data_ap = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    addSub () {
      var index = this.modal_data.sub.findIndex(x => x.item_code === this.modal_data_item.item_code)
      if (index < 0) {
        this.modal_data.sub.unshift(this.modal_data_item)
      } else {
        this.modal_data.sub[index] = this.modal_data_item
      }
      this.modal_item_active = false
      console.log(this.modal_data)
      this.calPriceAll()
    },
    editItem (val) {
      // this.modal_data = {}
      console.log(JSON.stringify(val))
      this.modal_data_item = val
      this.modal_item_active = true
    },
    addItem () {
      let temp_data = {
        'id': 0,
        'item_id': 0,
        'item_code': '',
        'item_name': '',
        'short_name': '',
        'adjust_type': 0,
        'description': '',
        'wh_id': 1,
        'wh_code': '01',
        'shelf_id': 1,
        'shelf_code': '01',
        'qty': 0,
        'unit_id': 0,
        'unit_code': '',
        'average_cost': 0,
        'sum_of_cost': 0,
        'stock_type': 0,
        'rate1': 1,
        'rate2': 1,
        'is_cancel': 0
      }
      this.modal_data_item = temp_data
      console.log(JSON.stringify(this.modal_data_item))
      this.modal_item_active = true
    },
    close_modal_item () {
      this.modal_item_active = false
    },
    addUnit (val) {
      let index = this.unit.find(x => x.id === val)
      console.log(index)
      if (index == null) {
      } else {
        this.modal_data_item.unit_code = index.unit_code
      }
      // this.modal_data.unit_code = val
      // console.log(this.modal_data.unit_code)
    },
    handleChangeItem (value, name) {
      console.log(`selected ${value}`)
      console.log(`selected ${name}`)
      this.modal_data_item.item_name = name
      this.getItem(value)
    },
    getProductAll () {
      this.$store.commit('Loading')
      apiItem.listProduct(
        this.REST_URL,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            // console.log(result)
            this.data_item = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getItem (val) {
      this.$store.commit('Loading')
      apiItem.itemById(this.REST_URL,
        this.header,
        {'id': parseInt(val)},
        result => {
          if (result.response === 'success') {
            // console.log(JSON.stringify(result))
            this.unit = result.data.bar_data
            this.modal_data_item.price = result.data.bar_data[0].price_1
            this.modal_data_item.unit_id = result.data.stk_unit_id
            this.modal_data_item.unit_code = result.data.stk_unit_code
            this.modal_data_item.stock_type = result.data.stock_type
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลไม่ได้',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    getUnit () {
      apiItem.itemUnit(this.REST_URL,
        this.header, {},
        result => {
          console.log(result)
          if (result.response === 'success') {
            this.unit = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลหน่วยนับไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    removeItem (index) {
      this.modal_data.sub.splice(index, 1)
      this.calPriceAll()
    },
    calPriceSub () {
      // this.modal_data.lot_qty = this.modal_data.qty
      this.modal_data_item.sum_of_cost = (this.modal_data_item.average_cost * this.modal_data_item.qty)
    },
    calPriceAll () {
      let SubAmount = 0
      for (let index = 1; index <= this.modal_data.sub.length; index++) {
        SubAmount += this.modal_data.sub[index - 1].sum_of_cost
      }
      this.modal_data.total_amount = SubAmount
      // this.modal_data_item.tax_amount = this.modal_data_item.after_discount_amount * 0.07
      // this.modal_data_item.before_tax_amount = this.modal_data_item.after_discount_amount - this.modal_data_item.after_discount_amount * 0.07
    }
  },
  created () {
    this.getCusAll()
    this.getUserAll()
    // this.getUnit()
  },
  mounted () {
    this.getProductAll()
    this.checkUser()
    this.getAll()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/adjust_item.js